export default {
    apiKey: "AIzaSyA_5h27ObFHZWNdGSh0ThdnXksRFWpOwkM",
    authDomain: "tawitech-ph.firebaseapp.com",
    databaseURL: "https://tawitech-ph.firebaseio.com",
    projectId: "tawitech-ph",
    storageBucket: "tawitech-ph.appspot.com",
    messagingSenderId: "230545171093",
    appId: "1:230545171093:web:944f5119dc8ddb9372319c",
    measurementId: "G-T7CFYQV6DD"
};